import * as types from "./mutation-types";

export default {
  [types.SAVE_DASHBOARD_DATA](state, dashboardData) {
    state.dashboardData = dashboardData;
  },
  [types.SAVE_STUDY_ID](state, studyId) {
    state.studyId = studyId;
  },
  [types.SAVE_SITES_DATA](state, sitesData) {
    state.sitesData = sitesData;
  },
  [types.SAVE_BENCHMARK_DATA](state, benchMarkData) {
    state.benchMarkData = benchMarkData;
  },
  [types.SAVE_ENROLLMENT_DATA](state, enrollmentData) {
    state.enrollmentData = enrollmentData;
  },
  [types.SAVE_ECONSENT_UPLOADED_DATA](state, eConsentUploadedData) {
    state.eConsentUploadedData = eConsentUploadedData;
  },
  [types.SAVE_TOP_SCREEN_FAIL_REASONS](state, topScreenFailuaresReason) {
    state.topScreenFailuaresReason = topScreenFailuaresReason;
  },
  [types.SAVE_QUIZ_DATA](state, quizData) {
    state.quizData = quizData;
  },
  [types.SAVE_RECRUITEMENT_DATA](state, recruitmentData) {
    state.recruitmentData = recruitmentData;
  },
  [types.SAVE_SENSOR_COMPLIANCE_DATA](state, sensorComplianceData) {
    state.sensorComplianceData = sensorComplianceData;
  },
  [types.SAVE_OVERALL_COLLECTION_DATA](state, overallCollectionData) {
    state.overallCollectionData = overallCollectionData;
  },
  [types.SAVE_CANCELLED_TH_VISIT_DATA](state, cacelledTelehealthVisits) {
    state.cacelledTelehealthVisits = cacelledTelehealthVisits;
  },
  [types.SAVE_COMPLIANCE_INSIGHT_SCORE](state, complianceInsightScore) {
    state.complianceInsightScore = complianceInsightScore;
  },
  [types.SAVE_OVERALL_COLLECTION_MISSING_DATA](state, overallCollectionMissingData) {
    state.overallCollectionMissingData = overallCollectionMissingData;
  },
  [types.SAVE_NON_COMPLIENT_ACTIVITIES](state, nonCompliantActivities) {
    state.nonCompliantActivities = nonCompliantActivities;
  },
  [types.SAVE_TH_VISITS_DURATION](state, telehealthVisitsDuration) {
    state.telehealthVisitsDuration = telehealthVisitsDuration;
  },
  [types.SAVE_COMPLIANCE_RATE_OVER_TIME](state, complianceRateOverTime) {
    state.complianceRateOverTime = complianceRateOverTime;
  },
  [types.SAVE_STUDY_COMPLIANCE_DATA](state, studyComplianceData) {
    state.studyComplianceData = studyComplianceData;
  },
  [types.SAVE_STUDY_PARTICIPANT_COMPLIANCE_DATA](state, studyParticipantComplianceData) {
    state.studyParticipantComplianceData = studyParticipantComplianceData;
  },
  [types.SAVE_OVERALL_COLLECTION_PARTICIPANT_DATA](state, overallCollectionParticipantData) {
    state.overallCollectionParticipantData = overallCollectionParticipantData;
  },
  [types.SAVE_GRAPHIC_COMPLIANCE_DATA](state, graphicComplianceData) {
    state.graphicComplianceData = graphicComplianceData;
  },
  [types.SAVE_ANALYTICS_USER_DATA](state, analyticsUsersData) {
    state.analyticsUsersData = analyticsUsersData;
  },
  [types.SAVE_DASHBOARD_REFRESH_DATA](state, dashboardRefreshData) {
    state.dashboardRefreshData = dashboardRefreshData;
  },
  [types.SAVE_SITE_BY_ID_DATA](state, siteById) {
    state.siteById = siteById;
  },
  [types.SAVE_ALL_ENROLLMENT_DATA](state, allEnrollmentData) {
    state.allEnrollmentData = allEnrollmentData;
  }
};
